import { render, staticRenderFns } from "./TopicEdit.vue?vue&type=template&id=702f9b3b&scoped=true&"
import script from "./TopicEdit.vue?vue&type=script&lang=js&"
export * from "./TopicEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702f9b3b",
  null
  
)

export default component.exports